import {
    InfoHint,
    InfoHintBody,
    InfoHintContent,
    InfoHintHeader,
    InfoHintTitle,
    InfoHintTrigger,
} from '@plato/ui/components/info-hint';
import type { LucideIcon } from 'lucide-react';
import { CircleSlash, TriangleAlert } from 'lucide-react';
import { useTranslation } from 'react-i18next';

type FlagHintProps = {
    icon: LucideIcon;
    iconClassName: string;
    title: string;
    description: string;
};

function FlagHint({ icon: Icon, iconClassName, title, description }: FlagHintProps) {
    return (
        <InfoHint>
            <InfoHintTrigger className="shrink-0">
                <Icon className={iconClassName} />
            </InfoHintTrigger>
            <InfoHintContent side="bottom">
                <InfoHintHeader>
                    <InfoHintTitle>{title}</InfoHintTitle>
                </InfoHintHeader>
                <InfoHintBody>{description}</InfoHintBody>
            </InfoHintContent>
        </InfoHint>
    );
}

/**
 * ⊘ marker for a user with an assigned book but zero footprint in the selected
 * period. Always renders — the caller decides whether to show it.
 */
export function InactiveFlag() {
    const { t } = useTranslation('team');

    return (
        <FlagHint
            icon={CircleSlash}
            iconClassName="h-4 w-4 text-neutral-400"
            title={t('user_table__inactive')}
            description={t('user_table__inactive_tooltip')}
        />
    );
}

/**
 * ⚠ marker for a user whose open churn € stands out vs. the team, relative to
 * their assigned revenue. Always renders — the caller decides whether to show it.
 */
export function ChurnRiskFlag() {
    const { t } = useTranslation('team');

    return (
        <FlagHint
            icon={TriangleAlert}
            iconClassName="h-4 w-4 text-amber-500"
            title={t('user_table__churn_risk_flag')}
            description={t('user_table__churn_risk_flag_tooltip')}
        />
    );
}
